import styled, { css } from 'styled-components';

const Wrapper = styled.div<{ isFullSize?: boolean; fillSlot?: boolean }>`
  display: flex;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;
  ${(props) => !props.isFullSize && !props.fillSlot && css`
    display: inline-flex;
    margin-right: 16px;
  `}
  ${(props) => props.fillSlot && css`
    flex: 1;
    min-width: 0;
  `}

  .video-player {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    overflow: hidden;
    ${(props) => !props.isFullSize && !props.fillSlot && css`
      min-height: 270px;
      width: 320px;
    `}
    ${(props) => props.fillSlot && !props.isFullSize && css`
      min-height: 270px;
      width: 100%;
    `}
    ${(props) => props.isFullSize && !props.fillSlot && css`
      width: 720px;
      min-height: 350px;
    `}
    ${(props) => props.isFullSize && props.fillSlot && css`
      width: 100%;
      height: 100%;
    `}
  }

  .video-player-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    z-index: 1;
  }

  .no-video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .preview-tooltip {
    position: absolute;
    bottom: 40px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 4px;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .preview-frame {
    width: 160px;
    height: 90px;
    background: #000;
    border-radius: 2px;
  }

  .preview-time {
    color: white;
    font-size: 12px;
  }

  .hidden-video {
    display: none;
  }

  .plyr__progress__container {
    position: relative;
  }

  .plyr {
    width: 100%;
    height: 100%;
  }

  .plyr video {
    object-fit: contain;
  }
`;

export default { Wrapper };
